// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tcLLu","type":"styles_type__2LvQb","choices":"styles_choices__3iswK"};